import { ActionBarAlign, ActionBarVerticalAlign } from './constants.js';

var getActionBarTextAlign = function getActionBarTextAlign(align) {
  switch (align) {
    case ActionBarAlign.Center:
      return "center";

    case ActionBarAlign.Right:
      return "right";

    case ActionBarAlign.Left:
    default:
      return "left";
  }
};
var getActionBarFlexAlign = function getActionBarFlexAlign(verticalAlign) {
  switch (verticalAlign) {
    case ActionBarVerticalAlign.Bottom:
      return "flex-end";

    case ActionBarVerticalAlign.Middle:
      return "center";

    case ActionBarVerticalAlign.Stretch:
      return "stretch";

    case ActionBarVerticalAlign.Top:
    default:
      return "flex-start";
  }
};

export { getActionBarFlexAlign, getActionBarTextAlign };
